import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController
} from "ionic-angular";
import { ToastController } from "ionic-angular";
import { TranslateService } from '@ngx-translate/core';

import { ClosingSalePage } from './../closing-sale/closing-sale';
import { GeneralExperiencePage } from './../general-experience/general-experience';
import { BqApiProvider } from '../../providers/bq-api/bq-api';


@IonicPage()
@Component({
  selector: 'page-xsell-upsell',
  templateUrl: 'xsell-upsell.html',
})
export class XsellUpsellPage {

  public xsellComment: string;

  public p44Selection: number;
  public p45Selection: number;
  public p46Selection: number;
  public p47Selection: number;
  public p48Selection: number;
  public p49Selection: number;
  public p50Selection: number;
  public p51Selection: number;
  public p52Selection: number;
  public p53Selection: number;
  public p54Selection: number;
  public p55Selection: number;

  constructor(
    private translate: TranslateService,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private bqApi: BqApiProvider
  ) {

    this.p44Selection = 0;
    this.p45Selection = 0;
    this.p46Selection = 0;
    this.p47Selection = 0;
    this.p48Selection = 0;
    this.p49Selection = 0;
    this.p50Selection = 0;
    this.p51Selection = 0;
    this.p52Selection = 0;
    this.p53Selection = 0;
    this.p54Selection = 0;
    this.p55Selection = 0;
    this.xsellComment = '';
  }

  ionViewDidLoad() {
    this.p44Selection = this.bqApi.getStep(44) || 0;
    this.p45Selection = this.bqApi.getStep(45) || 0;
    this.p46Selection = this.bqApi.getStep(46) || 0;
    this.p47Selection = this.bqApi.getStep(47) || 0;
    this.p48Selection = this.bqApi.getStep(48) || 0;
    this.p49Selection = this.bqApi.getStep(49) || 0;
    this.p50Selection = this.bqApi.getStep(50) || 0;
    this.p51Selection = this.bqApi.getStep(51) || 0;
    this.p52Selection = this.bqApi.getStep(52) || 0;
    this.p53Selection = this.bqApi.getStep(53) || 0;
    this.p54Selection = this.bqApi.getStep(54) || 0;
    this.p55Selection = this.bqApi.getStep(55) || 0;
    this.xsellComment = this.bqApi.getComment(6) || 0;
  }

  updateSteps(){
    if (this.p44Selection !== 0) {
      this.bqApi.setStep(44, this.p44Selection);
    }

    if (this.p45Selection !== 0) {
      this.bqApi.setStep(45, this.p45Selection);
    }

    if (this.p46Selection !== 0) {
      this.bqApi.setStep(46, this.p46Selection);
    }

    if (this.p47Selection !== 0) {
      this.bqApi.setStep(47, this.p47Selection);
    }

    if (this.p48Selection !== 0) {
      this.bqApi.setStep(48, this.p48Selection);
    }

    if (this.p49Selection !== 0) {
      this.bqApi.setStep(49, this.p49Selection);
    }

    if (this.p50Selection !== 0) {
      this.bqApi.setStep(50, this.p50Selection);
    }

    if (this.p51Selection !== 0) {
      this.bqApi.setStep(51, this.p51Selection);
    }

    if (this.p52Selection !== 0) {
      this.bqApi.setStep(52, this.p52Selection);
    }

    if (this.p53Selection !== 0) {
      this.bqApi.setStep(53, this.p53Selection);
    }

    if (this.p54Selection !== 0) {
      this.bqApi.setStep(54, this.p54Selection);
    }

    if (this.p55Selection !== 0) {
      this.bqApi.setStep(55, this.p55Selection);
    }

    if( this.xsellComment !== '' ){
      this.bqApi.setComment(6, this.xsellComment );
    }

    this.bqApi.syncSteps();
  }

  nextStep() {
    this.updateSteps();
    this.viewCtrl.dismiss();
    this.navCtrl.push(GeneralExperiencePage);
  }

  previousStep() {
    this.updateSteps();
    this.viewCtrl.dismiss();
    this.navCtrl.push(ClosingSalePage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/xsell-upsell/xsell-upsell.ts